<flx-heading size="medium" align="center" type="page" weight="extra-light">{{ docType === 'invoice' ? 'Invoice Job' : 'Quoting Job' }}</flx-heading>
<div class="instructions">
	<p>
		Please provide us with the line items that you want to reflect on your {{ docType }}. <br />
		On the next screen you will be able to generate an {{ docType }} and save a copy to your desktop.
	</p>
</div>
